export enum UserEditDisplayModeEnum {
  AlteredRides = "AlteredRides",
  AlteredByMeRides = "AlteredByMeRides",
  AlteredNotByMeRides = "AlteredNotByMeRides",
  AlteredByMeTodayRides = "AlteredByMeTodayRides",
  AlteredByMeNotTodayRides = "AlteredByMeNotTodayRides",
  AlteredNotByMeTodayRides = "AlteredNotByMeTodayRides",
  AlteredNotByMeNotTodayRides = "AlteredNotByMeNotTodayRides",
  NotAlteredRides = "NotAlteredRides",
  PassengerSelfRemoved = "PassengerSelfRemoved",
  AllRides = "AllRides",
}
